module.exports = "/_next/static/images/OgMarketing-abdc1daee07d7e2c30a1ee1cb47187e5.jpeg";